import { useState, useEffect } from "react";
import { SCREEN_MAP, SITE_TAG } from "../App";
import { supabase } from "../supabase";
import Canvas from "../Components/Canvas";

const Settings = () => {
    const [selectedPage, setSelectedPage] = useState({'zolder' : 'live', 'ghent_eddymerckx' : 'live'});

    const handleChange = (event, venueAlias) => {
        const screenTag = event.target.value;
        console.log("venueAlias'" + venueAlias + "', screenTag: '" + screenTag + "'");
        const updateScreenConfig = async () => {
            const { data, error } = await supabase
                .from('screen_configuration')
                .update([{ screen_tag: screenTag }])
                .eq('site', venueAlias);

            if (error) {
                console.error("Error updating screen configuration:", error);
            } else {
                console.log("Screen configuration updated:", data);
            }
        };

        updateScreenConfig();

        const screenTags = { ...selectedPage, [venueAlias]: screenTag };
        console.log("screenTags", screenTags)
        setSelectedPage(screenTags);
    };

    useEffect(() => {
        const fetchScreenConfig = async () => {
            const { data, error } = await supabase
                .from("screen_configuration")
                .select("site,screen_tag")
                //.eq("site", SITE_TAG).single();

            console.log(data);

            if (error) {
                console.error(error);
                return;
            }

            if (!data) {
                console.error("No screen configuration found for site", SITE_TAG);
                return;
            }

            let screenTags = {}
            data.forEach(row => {
                const screenTag = row['screen_tag'];
                if (Object.keys(SCREEN_MAP).includes(screenTag)) {
                    screenTags[row["site"]] = screenTag;                    
                }
                
            });
            setSelectedPage(screenTags);
        };

        fetchScreenConfig();
    }, []);

    function resetLaps(venueId){
        const resetLapsForVenue = async () => {
            const { data, error } = await supabase
                .from('screen_configuration')
                .update([{ reset_laps: true }])
                .eq('id', venueId);

            if (error) {
                console.error("Error resetting laps:", error);
            } else {
                console.log("Laps reset for venue:", data);
            }
        };

        resetLapsForVenue();
    }


    return (
        <Canvas showTime>
            <div className="container mx-5 px-4" style={{ "fontSize": "2em" }}>
                <div>
                    <h2>Settings</h2>
                </div>
                <h3>Gent</h3>

                Live screen:
                <select value={selectedPage['ghent_eddymerckx']} onChange={(event) => handleChange(event, 'ghent_eddymerckx')}>
                    {Object.keys(SCREEN_MAP).map((screen, index) => (
                        <option key={index} value={screen}>{screen}</option>
                    ))}
                </select><br/>
                <button onClick={() => resetLaps(1)}>Reset laps</button>

                <h3>Zolder</h3>

                Live screen:
                <select value={selectedPage['zolder']} onChange={(eventZolder) => handleChange(eventZolder, 'zolder')}>
                    {Object.keys(SCREEN_MAP).map((screen, index) => (
                        <option key={index} value={screen}>{screen}</option>
                    ))}
                </select><br/>
                <button onClick={() => resetLaps(2)}>Reset laps</button>

            </div>
        </Canvas>
    );
}

export default Settings;